export function SwotSupportDetails(props: { readonly correlationId?: string | undefined; readonly technicalDetails?: string | undefined; readonly diagnostics?: Record<string, string | number | boolean | null> | undefined }) {
  const entries = Object.entries(props.diagnostics ?? {}).filter(([, value]) => value !== null && value !== undefined);
  if (!props.correlationId && !props.technicalDetails && entries.length === 0) return null;
  return (
    <details className="swot-support-details">
      <summary>Support details</summary>
      {props.correlationId ? <p><strong>Correlation ID:</strong> {props.correlationId}</p> : null}
      {props.technicalDetails ? <p><strong>Technical details:</strong> {props.technicalDetails}</p> : null}
      {entries.length > 0 ? (
        <dl>
          {entries.map(([key, value]) => <div key={key}><dt>{key}</dt><dd>{String(value)}</dd></div>)}
        </dl>
      ) : null}
    </details>
  );
}
